export const BizAppConfig = {
  // 应用名称
  appName: '智能CRM',

  // 多语言应用名称
  appNames: {
    'zh-CN': '智能CRM',
    'zh-TW': '智能CRM',
    'en-US': 'AI CRM',
    'ja-JP': 'AI CRM',
  },

  // 应用 logo
  appLogo: process.env.UMI_APP_APP_LOGO,

  // 底部版权
  appFooterCopyright: process.env.UMI_APP_APP_FOOTER_COPYRIGHT,

  // 多语言底部版权
  appFooterCopyrights: {
    'zh-CN': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_TW,
    'en-US': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_EN_US,
    'ja-JP': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_JA_JP,
  },

  // API 地址（由不同环境配置文件注入 UMI_APP_API_URL）
  appApiUrl: process.env.UMI_APP_API_URL,

  // AI 对话平台地址
  chatPlatformUrl: process.env.UMI_APP_CHAT_PLATFORM_URL || '',

  // 历史配置字段，仅保留兼容；新版任务组件统一使用 openPlatformConfig，不读取此地址
  taskManagementApiUrl: process.env.UMI_APP_TASK_MANAGEMENT_API_URL || '',

  // 任务管理来源应用标识；默认使用当前 CRM 应用 UUID，联调时可用环境变量覆盖
  taskSourceAppUuid:
    process.env.UMI_APP_TASK_SOURCE_APP_UUID ||
    process.env.UMI_APP_SSO_CLIENT_ID ||
    'zy-crm',

  // ============ 新建应用需要修改！！！ ============
  // SSO 客户端ID（优先读取环境变量，否则用默认值）
  appSsoClientId: process.env.UMI_APP_SSO_CLIENT_ID,

  // SSO 授权地址
  appSsoAuthorizeUrl: process.env.UMI_APP_SSO_AUTHORIZE_URL,

  // SSO 登出地址
  appSsoLogoutUrl: process.env.UMI_APP_SSO_LOGOUT_URL,

  // 个人中心地址
  appPersonalCenterUrl: process.env.UMI_APP_PERSONAL_CENTER_URL,

  // 企业管理地址
  // 支持占位符：{tenantUuid}、{organizationUuid}
  appTenantManagementUrl: process.env.UMI_APP_TENANT_MANAGEMENT_URL,

  appOpenServiceUrl: process.env.UMI_APP_OPEN_SERVICE_URL || '',

  appOpenApiGatewayPath: process.env.UMI_APP_OPEN_API_GATEWAY_PATH || '',

  appOrganizationAdminCategoryCode:
    process.env.UMI_APP_ORGANIZATION_ADMIN_CATEGORY_CODE || '',

  // 工作台地址
  appWorkbenchUrl: process.env.UMI_APP_WORKBENCH_URL,
};
